
<h1>Timer.today</h1>

<p>Trying to solve time management in a more intuitive way.<br>

Timer.today is powered by <a href="https://svelte.dev" target="_blank">Svelte</a>
    & <a href="https://www.micronaut.io" target="_blank">Micronaut</a>.
    Report any issues via email using anatoli at radulov dot com.
If you like it, feel free to <a href="https://buymeacoffee.com/anatoli">Buy me a coffee :)</a></p>

<p>Created by Anatoli Radulov</p>
